export function strFormatAddAnOrA(str: string): string {
    return strStartsWithVowel(str) ? `an ${str}` : `a ${str}`
}

export function strStartsWithVowel(str: string): boolean {
    return !!str ? /^[aeiou]/i.test(str.toString()) : false
}
